import preview from '@/pages/preview/index'
import previewV2 from '@/pages/previewV2/index'

export default [
  {
    path: '/previewV1/:from/:type/:subfix/:documentId',
    name: 'preview',
    component: preview
  },
  {
    path: '/preview/:from/:type/:subfix/:documentId',
    name: 'previewV2',
    component: previewV2
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/preview.js